export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { value: '5000+', label: '漫画资源入库' },
    { value: '每日更新', label: '日韩热门连载' },
    { value: '永久免费', label: '无需注册登录' },
  ];

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20orange%20and%20coral%20tones%2C%20subtle%20comic%20speech%20bubble%20textures%2C%20artistic%20manga%20page%20line%20patterns%20fading%20at%20edges%2C%20clean%20modern%20style%2C%20warm%20lighting%2C%20minimal%20and%20elegant%20composition%20with%20plenty%20of%20negative%20space%20for%20text%20overlay&width=1800&height=900&seq=hero-bg-manga-01&orientation=landscape"
          alt="歪歪漫画网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 bg-primary-500/20 text-primary-200 rounded-full text-sm font-medium mb-5 whitespace-nowrap">
              免费漫画在线看
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
              歪歪漫画网
              <br />
              <span className="text-primary-300">日韩国漫免费阅读平台</span>
            </h1>

            <p className="text-lg md:text-xl text-white/80 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              聚合全网最全漫画资源，卡片式流畅阅读，热门日漫韩漫每日更新
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              歪歪漫画网专注为漫画爱好者提供歪歪漫画网站入口与歪歪漫画免费网站入口。收录海量日漫、韩漫、国漫大全，支持下拉式全集阅读模式，无需注册即可在线免费畅看完整漫画。每日同步更新连载，让你追更不等待。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-300">{stat.value}</div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line text-lg"></i>
                立即开始阅读
              </a>
              <a
                href="#features"
                onClick={(e) => handleClick(e, '#features')}
                className="inline-flex items-center gap-2 px-7 py-3 border border-white/30 text-white font-medium rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解平台特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20illustration%20of%20manga%20reading%20on%20a%20tablet%20device%2C%20colorful%20comic%20panels%20and%20speech%20bubbles%20floating%20around%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20cheerful%20and%20energetic%20vibe%2C%20modern%20flat%20illustration%20style%20with%20clean%20lines%2C%20white%20background%2C%20playful%20composition&width=800&height=1000&seq=hero-manga-visual-01&orientation=portrait"
                alt="歪歪漫画在线阅读展示"
                className="w-full h-auto rounded-xl"
              />
              <div className="absolute -bottom-3 -right-3 bg-accent-500 text-background-50 text-xs font-bold px-3 py-1.5 rounded-md whitespace-nowrap">
                每日更新
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}